/**
 * POPULATION-CARD.TSX
 * Open population dashboard
 */

import Card from "@/components/card"
import { Population } from "@/entities/population/model/population.types"
import { risksPopulationsNavItem } from "@/nav/nav.app"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { PhysicalRiskMeter } from "@/entities/physical-risk/ui/PhysicalRiskMeter"
import { useNavigate } from "react-router-dom"
import { ReactNode } from "react"
import { useRisksSpace } from "@/core/risks-space.context"
import RpsLevel from "./RpsLevel"

interface OwnProps {
  population: Population
}

//Pastille (ou jauge) du niveau de risque, puis son libelle
function RiskRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="flex items-center">
      {children}
      <div className="grey-t ml-[8px] text-sm font-bold">{label}</div>
    </div>
  )
}

export default function PopulationCard(props: OwnProps) {
  const navigate = useNavigate()
  const { getPath } = useRisksSpace()
  const { population } = props

  return (
    <Card
      onClick={() => navigate(getPath(`/populations/${population.id}`))}
      isWithoutPadding
      className="_hover mb-20 mr-20 w-[170px] overflow-hidden p-[20px]">
      <div
        className="absolute inset-0 -translate-y-[10px] scale-[1.03] bg-cover bg-center opacity-50"
        style={{ backgroundImage: `url(${require("@/assets/population-card-bg.png")})` }}
      />
      <div className="relative flex h-[200px] flex-col justify-between">
        <div className="text-center text-lg">{population.name}</div>
        <div className="flex items-end justify-between">
          <div className="flex flex-col gap-[16px]">
            <RiskRow label="RPS">
              <RpsLevel level={population.cRpsLevel} />
            </RiskRow>
            <RiskRow label="PHY">
              <PhysicalRiskMeter risk={population.cRiskMax} size="sm" />
            </RiskRow>
          </div>
          {population.size > 0 && (
            <div className="grey-t rounded-full bg-white px-[10px] py-[2px] text-lg">
              {risksPopulationsNavItem.icon && <FontAwesomeIcon icon={risksPopulationsNavItem.icon} className="mr-2" />}
              {population.size}
            </div>
          )}
        </div>
      </div>
    </Card>
  )
}
